import { render } from "./GridJurnalUmumDetail.vue?vue&type=template&id=86865cf2&scoped=true"
import script from "./GridJurnalUmumDetail.vue?vue&type=script&lang=js"
export * from "./GridJurnalUmumDetail.vue?vue&type=script&lang=js"

import "./GridJurnalUmumDetail.vue?vue&type=style&index=0&id=86865cf2&scoped=true&lang=css"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86865cf2"]])

export default __exports__